// @flow

import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import Link from 'react-router-dom/Link';

import type { Article as ArticleType } from '../../types/model';

import { getArticlesByCategoryId } from '../../redux/selectors';

import Article from './Article';

const Root = styled.div`
  position: relative;

  display: flex;
  max-height: 510px;
`;

const ContentWrap = styled.div`
  flex: 1;

  display: flex;
  margin: 15px 90px;
`;

const Sidebar = styled.div`
  width: 300px;
  margin-right: 30px;
`;

const SidebarHeader = styled.h3`
  margin: 0 0 9px 0;

  font-weight: normal;
  font-size: 27px;

  color: ${props => props.color ? props.color : '#3C3C3C'};
`;

const FeaturedProduct = styled(Link)`
  text-decoration: none;
  color: #3C3C3C;
`

const ProductTitle = styled.h4`
  margin: 0;

  font-weight: normal;
  font-size: 27px;
`

const ProductDescription = styled.div`
  font-size: 13px;
  font-family: 'Georgia', serif;
  font-weight: normal;
  line-height: 1.2;
`

const ContentHeader = styled.h3`
  margin: 0 0 9px 0;

  font-weight: normal;
  font-size: 27px;

  color: ${props => props.color ? props.color : '#3C3C3C'};
`;

const Content = styled.div`
  flex: 1;
`

const ArticleList = styled.div`
  display: flex;
`

type Props = {
  color: ?string,
  articles: ArticleType[],
}

function ArticlesDrawer({ color, articles }: Props) {
  return (
    <Root>
      <ContentWrap>
        <Sidebar>
          <SidebarHeader color={color}>
            Featured Neuromodulation Product
          </SidebarHeader>

          <FeaturedProduct to="/products/7">
            <ProductTitle>
              The Absorb GT1 (Absorb) BVS
            </ProductTitle>

            <ProductDescription>
              <p>
                This breakthrough technology repairs and revascularizes like the best-in-class
                XIENCE drug-eluting stent. Unlike a drug-eluting stent that is a permanent metallic
                implant, Absorb is naturally resorbed in the body, leaving nothing behind.
              </p>
              <p>
                The Absorb bioresorbable technology offers more than a device-free artery.
                Absorb also restores** vasomotor function and pulsatility, allowing the artery
                to more naturally regulate blood flow.
              </p>
            </ProductDescription>

          </FeaturedProduct>
        </Sidebar>
        <Content>
          <ContentHeader color={color}>
            Important information in this section
          </ContentHeader>

          <ArticleList>
            {articles.map((article, index) => (
              <Article
                key={index.toString()}
                id={article.id}
                title={article.title}
                subTitle="Simple and reliable charging"
                description={`
                  Chronic pain affects approximately 1.5 billion people worldwide,
                  more than heart disease, cancer and diabetes combined. The condition can
                  negatively impact personal relationships, work productivity and a patient’s
                  daily routine
                `}
              />
            ))}
          </ArticleList>
        </Content>
      </ContentWrap>
    </Root>
  );
}

function mapStateToProps(state, props) {
  const categoryId = props.match.params.id;

  return ({
    articles: getArticlesByCategoryId(state, categoryId),
  })
}

export default connect(mapStateToProps)(ArticlesDrawer);



// WEBPACK FOOTER //
// ./src/components/ArticlesDrawer/ArticlesDrawer.js